@if (icon()) {
  <i [ngClass]="{ huge: theme() === 'sds' }" [innerHtml]="icon()"></i>
}
@if (text()) {
  <h4>{{ text() }}</h4>
}
<div class="additional-content">
  <ng-content></ng-content>
</div>
